import React from 'react';
import DOMAIN_FOOTER_MAP from '../../resources/footer';
import '../../static/css/style.css';

function DomainFooter() {
  React.useEffect(function setup() {
    var resizeTimer = null;
    var mutationObserver = null;

    function detectSidebarWidth() {
      var sider = document.querySelector('.ant-layout-sider');

      if (!sider) {
        // hiç sidebar yok => mobile veya login
        return 0;
      }

      // Ant Design collapsed kontrolü
      if (sider.classList.contains('ant-layout-sider-collapsed')) {
        return 80; // kapalı
      }

      return 280; // açık
    }

    function setSidebarCssVar() {
      var w = detectSidebarWidth();

      document.documentElement.style.setProperty('--sidebar-width', w + 'px');
      document.documentElement.style.setProperty(
        '--footer-text',
        w > 0 ? 'left' : 'center'
      );

      var footer = document.querySelector('.domain-footer-fixed');
      if (footer) {
        var h = footer.offsetHeight || 56;
        document.documentElement.style.setProperty('--footer-height', h + 'px');
        document.body.style.paddingBottom = h + 'px';
      }
    }

    // content render olduktan sonra çağır:
    setTimeout(setSidebarCssVar, 50);

    // Sider aç/kapa event’leri için:
    window.addEventListener('resize', setSidebarCssVar);

    // Debounce wrapper for resize
    function onResizeDebounced() {
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        setSidebarCssVar();
      }, 80);
    }

    // Kalıcı MutationObserver: DOM değişikliklerinde setSidebarCssVar çağrılır.
    function startObserver() {
      try {
        mutationObserver = new MutationObserver(function(mutations) {
          // herhangi bir değişiklik olunca debounce'lu olarak yeniden hesapla
          if (resizeTimer) clearTimeout(resizeTimer);
          resizeTimer = setTimeout(function() {
            setSidebarCssVar();
          }, 60);
        });

        mutationObserver.observe(document.body, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['style', 'class'],
        });
      } catch (e) {
        // MutationObserver desteklenmiyorsa fallback: zamanlı check
        setInterval(setSidebarCssVar, 1000);
      }
    }

    // İlk çağrı
    setSidebarCssVar();
    startObserver();
    window.addEventListener('resize', onResizeDebounced);

    // cleanup
    return function cleanup() {
      try {
        window.removeEventListener('resize', onResizeDebounced);
        if (resizeTimer) {
          clearTimeout(resizeTimer);
          resizeTimer = null;
        }
        if (mutationObserver) {
          mutationObserver.disconnect();
          mutationObserver = null;
        }

        // body.padding-bottom geri al
        var added = document.body.dataset.domainFooterPadding;
        if (added) {
          var current =
            window.getComputedStyle(document.body).paddingBottom || '0px';
          var currentValue = parseFloat(current) || 0;
          var sub = parseFloat(added) || 0;
          var newVal = Math.max(0, currentValue - sub);
          document.body.style.paddingBottom = newVal + 'px';
          delete document.body.dataset.domainFooterPadding;
        }

        // css değişkenlerini temizle
        document.documentElement.style.removeProperty('--sidebar-width');
        document.documentElement.style.removeProperty('--footer-height');
        document.documentElement.style.removeProperty('--footer-text');
      } catch (e) {
        // sessizce geç
      }
    };
  }, []);

  // host -> footer text
  var host =
    typeof window !== 'undefined' && window.location && window.location.hostname
      ? window.location.hostname
      : 'default';
  var text = DOMAIN_FOOTER_MAP[host] || DOMAIN_FOOTER_MAP.default;

  // Stil: left ve width artık CSS değişkenleriyle yönetiliyor; text-align CSS değişkeninden alınır

  return React.createElement(
    'footer',
    {
      className: 'domain-footer-fixed',
      role: 'contentinfo',
      'aria-label': 'site-footer',
    },
    text
  );
}

export default DomainFooter;
